import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { patientApi, patientErr } from "@/lib/patientApi";
import { toast } from "sonner";
import { Receipt, CaretLeft, CaretRight, Storefront } from "@phosphor-icons/react";

const rp = (n) => (n === null || n === undefined ? "—" : "Rp " + (Number(n) || 0).toLocaleString("id-ID"));
export const STATUS_BADGE = {
  menunggu_ongkir: { t: "Menunggu Ongkir", c: "bg-amber-100 text-amber-700" },
  menunggu_pembayaran: { t: "Menunggu Pembayaran", c: "bg-blue-100 text-blue-700" },
  kedaluwarsa: { t: "Kedaluwarsa", c: "bg-slate-200 text-slate-600" },
  dibatalkan: { t: "Dibatalkan", c: "bg-rose-100 text-rose-600" },
};

export default function ShopOrders() {
  const nav = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    document.title = "Pesanan Belanja — HalloGBS";
    if (!localStorage.getItem("patient_token")) { nav("/pasien/masuk?returnTo=/pesanan-belanja"); return; }
    patientApi.get("/patient/shop/orders").then((r) => { setOrders(r.data.orders); setLoaded(true); }).catch((e) => { toast.error(patientErr(e)); setLoaded(true); });
  }, [nav]);

  return (
    <div className="min-h-screen bg-[#FAF7FF]" data-testid="shop-orders-page">
      <header className="sticky top-0 z-20 flex items-center justify-between border-b border-pink-100 bg-white/90 px-4 py-3 backdrop-blur">
        <Link to="/belanja" data-testid="orders-back" className="flex items-center gap-1.5 text-sm font-bold text-[#7C4DE0]"><CaretLeft size={18} weight="bold" /> Belanja</Link>
        <h1 className="flex items-center gap-2 font-heading text-lg font-extrabold text-[#4C1D95]"><Receipt size={20} weight="duotone" className="text-[#DB2777]" /> Pesanan Saya</h1>
        <span className="w-16" />
      </header>

      <div className="mx-auto max-w-2xl space-y-3 px-4 py-5">
        {loaded && orders.length === 0 && (
          <div className="rounded-2xl border border-pink-100 bg-white p-10 text-center" data-testid="orders-empty">
            <Storefront size={40} weight="duotone" className="mx-auto text-[#C9B6F0]" />
            <p className="mt-2 text-sm text-slate-400">Belum ada pesanan.</p>
            <Link to="/belanja" className="mt-3 inline-block rounded-xl bg-[#7C4DE0] px-4 py-2 text-xs font-bold text-white">Mulai Belanja</Link>
          </div>
        )}
        {orders.map((o) => {
          const b = STATUS_BADGE[o.status] || { t: o.status, c: "bg-slate-100 text-slate-600" };
          return (
            <button key={o.id} data-testid={`order-card-${o.order_no}`} onClick={() => nav(`/pesanan-belanja/${o.order_no}`)} className="flex w-full items-center gap-3 rounded-2xl border border-pink-100 bg-white p-4 text-left transition-transform hover:-translate-y-0.5 active:scale-[0.99]">
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2"><span className="font-bold text-slate-800">{o.order_no}</span><span className={`rounded-full px-2 py-0.5 text-[10px] font-bold ${b.c}`}>{b.t}</span></div>
                <p className="mt-0.5 text-xs text-slate-400">{o.items.length} item · {o.fulfillment_type === "pickup" ? "Ambil di GBS" : "Dikirim"}</p>
                <p className="mt-1 text-sm font-extrabold text-[#DB2777]">{o.total === null ? "Total menunggu ongkir" : rp(o.total)}</p>
              </div>
              <CaretRight size={18} weight="bold" className="shrink-0 text-slate-300" />
            </button>
          );
        })}
      </div>
    </div>
  );
}
